import React from 'react'

import Head from 'next/head';

import FooterNavComponent from '../../components/FooterComponent/FooterNavComponent/FooterNavComponent';
import GetInTouchComponent from '../../components/FooterComponent/GetInTouchComponent/GetInTouchComponent';
import HeaderComponent from '../../components/HeaderComponent/HeaderComponent';
import { NextHead } from '../../components/NextHead/NextHead';
import VenueList from '../../components/VenueComponent/VenueList';
import { AxiosInstance } from '../../utilities';

const VenueListComponent = (props) => {
  return (
    <>
      <NextHead {...props.seoData} />
      <Head>
        <link rel="canonical" href={`${process.env.BASE_URL}/venues`} />
      </Head>
      <HeaderComponent />
      <VenueList {...props}/>
      <GetInTouchComponent />
      <FooterNavComponent />
    </>
  )
}

export default VenueListComponent


export async function getServerSideProps(context) {
  let data = [];

  try{
    const resp = await AxiosInstance(4008, "application/json").get('/cities')
    const response = resp.data
    if(response.status === 200){
      data = response.data
    }
  }catch(err){
    //handle additional errors
    console.error(err)
  }

  return { props: { cities: data } };
}
